<template>
    <div>
        <div>
            <span class="cs-homework-name" @click="onClick">{{name}}</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.cs-homework-name {
    color: #409EFF;
    cursor: pointer;
}
</style>

<script>
export default {
    props: {
        data: {},
    },
    data() {
        return {
            name: '',
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                this.name = this.data.Name;
            }
        },
        onClick() {
            let data = {
                action: "nav",
                data: this.data
            }
            this.$emit("customEvent",data);
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/homeworkNameCell.vue